export const OPERATORS_MAP: Record<string, { value: string; label: string }> = {
    IN: {
        value: 'in',
        label: 'is',
    },
    NOT_IN: {
        value: 'not_in',
        label: 'is not',
    },
}
